import dateFormat from 'dateformat'
import Countdown from 'react-countdown'
import { RiAlarmFill } from 'react-icons/ri'

const Counting = ({ days, hours, minutes, seconds }: any) => {
  return (
    <>
      {days} days {hours < 2 ? `0${hours}` : hours}:
      {minutes < 10 ? `0${minutes}` : minutes}:
      {seconds < 10 ? `0${seconds}` : seconds}
    </>
  )
}

const EndingDate = ({ date }: any) => {
  return <>{dateFormat(date, 'd/m/yy @ h:MM TT')}</>
}

const BidCountdown = ({
  date,
  inCarousel = false,
  hideClock = false,
  pastAuction = false,
  homePage = false,
  itemClosed = false,
  textClass = '',
  hideEnds = false,
  countdownClass = '',
}: {
  date: string
  inCarousel?: boolean
  hideClock?: boolean
  pastAuction?: boolean
  homePage?: boolean
  itemClosed?: boolean
  textClass?: string
  hideEnds?: boolean
  countdownClass?: string
}) => {
  const Completionist = (val: any) => {
    return (
      <p
        className={`font-bold uppercase ${
          inCarousel ? 'text-xs' : 'text-10 md:text-xs'
        } ${!pastAuction && textClass ? textClass : 'text-bidfta-red'}`}
      >
        {val?.itemClosed || pastAuction ? 'Auction Ended' : 'Auction Closing'}
      </p>
    )
  }

  // Renderer callback with condition

  const renderer = ({ days, hours, minutes, seconds, completed }: any) => {
    if (completed) {
      // Render a completed state
      return <Completionist itemClosed={itemClosed} />
    }

    const endingSoon = !completed && days < 1
    // Render a countdown
    return (
      <div
        className={`flex items-center ${
          textClass ||
          (endingSoon || completed ? 'text-bidfta-red' : 'text-[#132c52]')
        }`}
      >
        {!hideClock && <RiAlarmFill size={20} />}
        <p
          suppressHydrationWarning
          className={`font-bold uppercase leading-5 ${
            countdownClass
              ? countdownClass
              : inCarousel
              ? 'text-xs'
              : 'text-10 md:text-xs'
          } ${!hideClock ? 'ml-1 mt-0.5' : ''}`}
        >
          {!hideClock && !hideEnds ? 'ENDS: ' : ''}
          {homePage && days > 1 ? (
            <>
              <EndingDate date={date} /> EST
            </>
          ) : (
            <Counting
              days={days}
              hours={hours}
              minutes={minutes}
              seconds={seconds}
            />
          )}
        </p>
      </div>
    )
  }

  return (
    <Countdown date={date} renderer={renderer}>
      <Completionist itemClosed={itemClosed} />
    </Countdown>
  )
}

export default BidCountdown
